module.exports = __webpack_public_path__ + "static/media/shuttlecock.379cb9c0.svg";